import { RaceShield } from "@/components/race-shield"
import { VsDiamond } from "@/components/vs-diamond"
import { getRaceDisplayName, getTeamInitials } from "@/lib/race-colors"
import { cn } from "@/lib/utils"

function formatTV(tv: number): string {
  return `${Math.round(tv / 1000) * 1000 !== tv ? tv : tv / 1000}k`
}

interface TeamSide {
  name: string
  race: string
  colorHue: number | null
  teamValue: number
  isUser: boolean
  coachName?: string
}

function TeamPanel({ team }: { team: TeamSide }) {
  return (
    <div className="min-w-0 flex-1 text-center">
      <RaceShield
        race={team.race}
        hue={team.colorHue ?? undefined}
        label={getTeamInitials(team.name)}
        size="lg"
        className="mx-auto mb-2"
      />
      <h2
        className={cn(
          "font-display text-2xl leading-none font-bold",
          team.isUser && "text-gold-sm",
        )}
        style={!team.isUser ? { color: "var(--foreground)" } : undefined}
      >
        {team.name}
      </h2>
      <div
        className="mt-1 text-[10px] font-bold tracking-widest uppercase"
        style={{ color: "var(--muted-foreground)" }}
      >
        {getRaceDisplayName(team.race)} · TV {formatTV(team.teamValue)}
      </div>
      {team.coachName ? (
        <div
          className="mt-0.5 text-[10px]"
          style={{ color: "var(--muted-foreground)" }}
        >
          Coach {team.coachName}
        </div>
      ) : null}
    </div>
  )
}

export function VsMatchup({ home, away }: { home: TeamSide; away: TeamSide }) {
  return (
    <div className="flex items-center justify-center gap-6 md:gap-12">
      <TeamPanel team={home} />
      <VsDiamond />
      <TeamPanel team={away} />
    </div>
  )
}
